/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const AuthorOption = styled.div({
  display: 'flex',
  alignItems: 'center',
  padding: `0 ${token('space.050', '4px')}`,
  '> :first-child': {
    marginRight: token('space.050', '4px'),
  },
});
